import { useEffect, useState } from "react";
import { INiche } from "services/types";
import { Columnizer } from "components/blocks";
import { NichePreview } from "components/niches";
import { useMyNichesQuery } from "queries";
import { clsx } from "clsx";

import "./NicheBrowser.scss";

/* eslint-disable no-magic-numbers */

const COLUMN_SIZES = [500];

/* eslint-enable no-magic-numbers */

export const NicheBrowser = (props: {
  niches: INiche[];
  myWithPreview?: boolean;
  myNiche?: boolean;
}): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);

  const my = useMyNichesQuery({
    previews: false,
  });

  useEffect(() => {
    if (my.status === "success" && my.data !== undefined) {
      const ids = my.data.niches.map((niche: INiche): string => {
        return niche.id;
      });

      setFollowing((prev) => ids);
    }
  }, [my.status, my.data]);

  const isFollowing = (id: string): boolean => {
    return following.indexOf(id) >= 0;
  };

  const addFollowing = (id: string): void => {
    setFollowing((prev) => [...prev, id]);
  };

  const removeFollowing = (id: string): void => {
    setFollowing((prev) => {
      return prev.filter((x) => x !== id);
    });
  };

  const onFollow = (id: string, status: boolean): void => {
    if (status) {
      addFollowing(id);
    } else {
      removeFollowing(id);
    }
  };

  const classes = clsx([
    "niches",
    "nicheBrowser",
    {
      "niches--isMyNiche": props.myNiche,
      "niches--isMyWithPreview": props.myWithPreview,
      "niches--isMyWithoutPreview": !props.myWithPreview,
    }
  ]);

  return (
    <div className={classes}>
      <Columnizer sizes={COLUMN_SIZES}>
        {props.niches.map((niche: INiche, index: number) => (
          <NichePreview
            key={niche.id}
            niche={niche}
            following={isFollowing(niche.id)}
            onFollow={onFollow}
            isLink={props.myNiche}
          />
        ))}
      </Columnizer>
    </div>
  );
};
